







































































































































































































































































import skillbar from '@/components/skillbar.vue';
import SelectSearch from '@/components/select-search.vue';
import { ref, defineComponent, onMounted, computed } from '@vue/composition-api';
import store from '@/store';
// import router from '@/router';
import validation from '@/data/validation.vue';
import Vue from 'vue';

const bus = new Vue();

const isLocal = process.env.VUE_APP_RUN_ENV === 'local';
const isProd = process.env.VUE_APP_BUILD === 'production';
const defaultObjInit = () => ({
  skillId: '',
  name: '',
  skillMasterId: '',
  ratingDescription: 0,
  description: '',
  ratingName: '',
  addToMyPlan: false,
  isMandatory: false,
  MyPlan_Relevant: false,
  subSkills: [
    {
      skillId: '',
      name: '',
      skillMasterId: '',
      ratingDescription: 0,
      description: '',
      ratingName: '',
      addToMyPlan: false,
    },
  ],
});
export default defineComponent({
  name: 'Industry',
  components: {
    skillbar,
    SelectSearch,
    validation,
  },
  setup() {
    const selectedIndustries = ref([defaultObjInit()]);
    const extraInfoOptions = ref({});
    const mobileValidationMessage = ref({
      title: '',
      description: '',
      prefix: '',
      suffix: '',
    });
    const errorMessage = ref({
      title: null,
      message: null,
    });
    const isChangeRole = ref(false);
    const isButtonCheck = ref(false);
    const renderReady = ref(false);
    const apiError = ref(false);
    const loading = ref(false);
    const industryMandate = ref(false);
    const toggleAccordianVal = ref(1);
    const tag = ref('');
    const showPopup = ref(false);
    const name = ref('');
    const isInfoMessage = ref(false);
    const infoMessageTitle = ref('');
    const infoMessageDefinition = ref('');
    const infoMessageDescription = ref('');
    const infoMessageProficiencyLevels = ref('');
    const isRoleValue = ref('');
    const isFunctionValue = ref('');
    const openValidationModal = ref(false);
    const openExtraModal = ref(false);
    const showValidation = ref(false);
    const showInfo = ref(false);
    const showSkill = ref(false);
    const showExtraOption = ref(false);
    const infoType = ref('');
    const fetchInitialData = () => {
      store.dispatch('industry/getIndustries');
      store.dispatch('profile/getEmployeeProfile');
      store.dispatch('profile/getSkillsProficiency');
      renderReady.value = true;
    };
    onMounted(() => {
      fetchInitialData();
    });
    const skillsIndustries = computed(() => store.getters['industry/skillsIndustries']);
    const skillsEmployeeProfile = computed(() => store.getters['profile/skillsEmployeeProfile']);
    const skillsLevels = computed(() => store.getters['profile/skillsLevels']);
    const proceedButtonState = computed(() => {
      const arr = JSON.parse(JSON.stringify(selectedIndustries.value));
      /* eslint operator-linebreak: ["error", "after"] */
      if (arr.length === 1 && arr.find((x: any) => x.addToMyPlan) && arr[0].name.toLowerCase() === 'not available') return false;
      return (
        arr.find((x: any) => x.skillId === '') ||
        !(arr.find((x: any) => x.name.toLowerCase() === 'not available') || arr.find((x: any) => (x.addToMyPlan ? x.MyPlan_Relevant : false))) ||
        !!arr.find(
          (x: any) =>
            // eslint-disable-next-line implicit-arrow-linebreak
            !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
            (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
        )
      );
      // return (
      //   arr.find((x: any) => x.skillId === '') ||
      //   !!arr.find(
      //     (x: any) =>
      //       // eslint-disable-next-line implicit-arrow-linebreak
      //       !(x.addToMyPlan ? x.name.toLowerCase() === 'not available' : x.name.toLowerCase() === 'not available' || x.name.toLowerCase() === 'not applicable' || x.name.toLowerCase() === 'na') &&
      //       (!x.skillId || !x.ratingDescription || (x.subSkills.length && !x.subSkills.find((y: any) => y.ratingDescription))),
      //   )
      // );
    });
    const proceedToNextPage = () => {
      bus.$emit('proceedToNextPage', selectedIndustries);
    };
    const proceedToNextTab = (path: any) => {
      if (!skillsEmployeeProfile.value.profileComplete && !skillsEmployeeProfile.value.isLegacy && !isChangeRole.value) {
        isButtonCheck.value = true;
        bus.$emit('proceedToNextPage', isChangeRole, isButtonCheck);
      } else if (isChangeRole.value) {
        // @ts-ignore
        this.$router.push(path);
      }
    };
    const openSkillDefinition = (index: any) => {
      bus.$emit('openSkillDefinition', index);
    };
    const showExtraOptionsModal = (index: any) => {
      bus.$emit('showExtraOptionsModal', index);
    };
    const addRow = () => {
      selectedIndustries.value.push(defaultObjInit());
    };
    const deleteRow = (i: any, r: any) => {
      const index = i;
      const row = r;
      console.log('row', row);
      // if (typeof index === 'object' && !row) {
      //   index = extraInfoOptions.value.index;
      //   row = extraInfoOptions.value.type;
      // }
      selectedIndustries.value = [...selectedIndustries.value.slice(0, index), ...selectedIndustries.value.slice(index + 1, selectedIndustries.value.length)];
    };
    const toggleAccordian = () => {
      toggleAccordianVal.value = 0;
    };
    const toggleAccordianaddvalue = (i: any) => {
      toggleAccordianVal.value = i + 1;
    };
    const inputValueChanged = (val: any, elem: any) => {
      // console.log('val====================', val);
      // console.log('elem-----------------------', elem);
      // const { key } = elem.dataset;
      // const { id } = elem || {};
      const id = elem || {};
      if (id && id.includes('industry-select-')) {
        const index = parseInt(id.split('industry-select-')[1], 10);
        const obj = skillsIndustries.value?.find((x: any) => x.skillId === val.value);
        selectedIndustries.value[index].skillId = obj.skillId;
        selectedIndustries.value[index].name = obj.name;
        selectedIndustries.value[index].ratingDescription = obj.ratingDescription || 0;
        selectedIndustries.value[index].addToMyPlan = obj.addToMyPlan;
        selectedIndustries.value[index].MyPlan_Relevant = false;
        selectedIndustries.value[index].description = obj.description || '';
        selectedIndustries.value[index].subSkills = JSON.parse(JSON.stringify(obj.subSkills || []));
      }
    };
    const radioBtnClicked = (event: any) => {
      const { target } = event;
      const { id, dataset } = target;
      const { index, subIndex } = dataset;
      // if ((isIE || isEdge) && !isMobileOnly) return;
      if (id && id.includes('sub-industry-radio-') && selectedIndustries.value[index].subSkills[subIndex].ratingDescription) {
        selectedIndustries.value[index].subSkills[subIndex].ratingDescription = 0;
      } else if (id && id.includes('industry-radio-') && selectedIndustries.value[index].ratingDescription && !subIndex) {
        // selectedIndustries.value[index].Level = 0;
      }
    };
    return {
      baseUrl: isProd ? 'https://genome.genpact.com' : 'https://gencinduatgenomewapp.azurewebsites.net',
      selectedIndustries,
      skillsLevels,
      isChangeRole,
      renderReady,
      apiError,
      loading,
      toggleAccordianVal,
      skillsEmployeeProfile,
      inputValueChanged,
      radioBtnClicked,
      toggleAccordianaddvalue,
      toggleAccordian,
      skillsIndustries,
      deleteRow,
      addRow,
      extraInfoOptions,
      proceedToNextPage,
      industryMandate,
      proceedButtonState,
      tag,
      name,
      isInfoMessage,
      infoMessageTitle,
      infoMessageDefinition,
      infoMessageDescription,
      infoMessageProficiencyLevels,
      isRoleValue,
      isFunctionValue,
      errorMessage,
      mobileValidationMessage,
      showPopup,
      openValidationModal,
      openExtraModal,
      isLocal,
      // router,
      showValidation,
      showInfo,
      infoType,
      openSkillDefinition,
      showSkill,
      showExtraOptionsModal,
      showExtraOption,
      bus,
      proceedToNextTab,
      isButtonCheck,
    };
  },
});
